<template>
  <section :class="['section', 'cta__list', '--triangle-black', 'w-95', {'--dark': content.dark}]">
    <CTABlock v-for="block in content.items" :key="block.flexKey" :content="block" v-reveal/>
  </section>
</template>

<script>
import {CTABlock} from '@/components/blocks'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'CTAsSection',
  mixins: [HasContentMixin],
  components: {CTABlock}
}
</script>